import checkAge from './checkAge';

export const uk = {
  checkAge,
};
